module.exports = __webpack_public_path__ + "assets/media/day19.4b1f5c66.mp3";